import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../auth.service';
import { Router } from '@angular/router';
import { RoleService } from '../../../@core/services/role.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  // userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  userMenu = [
    { title: 'Profile', action: 'profile' },
    // { title: 'Log out', action: 'logout' }
  ];
  notificationMenu = [
    { title: 'No Notification'},
    // { title: 'Log out', action: 'logout' }
  ];
  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private authService: AuthService, 
              private router: Router,
              private roleService: RoleService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
      
      setTimeout(() => {
        this.sidebarService.collapse('menu-sidebar');
      }, 0); 
  }

  onMenuItemClick(event: any) {
    debugger;
    if (event?.title === 'Log out') {
      this.logout();
    } else if (event?.title === 'Profile') {
      this.goToProfile();
    }
  }

  // logout() {
  //   this.authService.logout();
  //   this.router.navigate(['/login']); // Redirect to the login page
  // }
  logout() {
    // Clear session or token (if applicable)
    this.roleService.logout();   
    sessionStorage.removeItem('userToken');
    localStorage.removeItem('userToken');
    // sessionStorage.removeItem('role');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('user_id');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    sessionStorage.clear();
    // Navigate to login page (or any other page)
    this.router.navigate(['/login']);
  }

  goToProfile() {
    this.router.navigate(['/profile']); // Redirect to the profile page
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  openHelpLink() {
  window.open('https://sourcebuddy.idamtat.in/', '_blank');
}

}
